import React, { useContext } from "react";
import Styles from "../../styles/Admin.module.css";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../context/user/UserContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUsers,
  faUserShield,
  faClipboardList,
  faExclamationTriangle,
  faMapMarkerAlt,
  faLink,
  faChartLine
} from "@fortawesome/free-solid-svg-icons";

const Admin = () => {
  const navigate = useNavigate();
  const { userData } = useContext(UserContext);
  
  // Get current time for greeting
  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "Good morning";
    if (hour < 18) return "Good afternoon";
    return "Good evening";
  };

  return (
    <div className={Styles.container}>
      <h1 className={Styles.title}>Admin Dashboard</h1>
      
      <p className={Styles.welcomeMessage}>
            {getGreeting()}, {userData?.user?.username || "Admin"}! Welcome to your dashboard.
      </p>
      
      <h2 className={Styles.sectionTitle}>Quick Actions</h2>
      <div className={Styles.admin_dashboard}>
        <div className={Styles.admin_dashboard__button}>
          <button
            className={Styles.admin_dashboard__button_analytics}
            onClick={() => navigate("/analytics")}
          >
            <span className={Styles.icon}>
              <FontAwesomeIcon icon={faChartLine} />
            </span>
            Analytics
            <div className={Styles.description}>
              Track growth, subscriptions, revenue, referrals and app traffic
            </div>
          </button>
        </div>

        <div className={Styles.admin_dashboard__button}>
          <button
            className={Styles.admin_dashboard__button_users}
            onClick={() => navigate("/users")}
          >
            <span className={Styles.icon}>
              <FontAwesomeIcon icon={faUsers} />
            </span>
            Users
            <div className={Styles.description}>
              Manage user accounts, permissions, and activity
            </div>
          </button>
        </div>
        
        <div className={Styles.admin_dashboard__button}>
          <button
            className={Styles.admin_dashboard__button_reported_users}
            onClick={() => navigate("/reportedusers")}
          >
            <span className={Styles.icon}>
              <FontAwesomeIcon icon={faUserShield} />
            </span>
            Reported Users
            <div className={Styles.description}>
              Review and moderate user reports and violations
            </div>
          </button>
        </div>
        
        <div className={Styles.admin_dashboard__button}>
          <button
            className={Styles.admin_dashboard__button_posts}
            onClick={() => navigate("/posts")}
          >
            <span className={Styles.icon}>
              <FontAwesomeIcon icon={faClipboardList} />
            </span>
            Posts
            <div className={Styles.description}>
              View and manage all user posts and content
            </div>
          </button>
        </div>
        
        <div className={Styles.admin_dashboard__button}>
          <button
            className={Styles.admin_dashboard__button_reports}
            onClick={() => navigate("/reports")}
          >
            <span className={Styles.icon}>
              <FontAwesomeIcon icon={faExclamationTriangle} />
            </span>
            Reported Posts
            <div className={Styles.description}>
              Review and moderate reported content
            </div>
          </button>
        </div>
        
        <div className={Styles.admin_dashboard__button}>
          <button
            className={Styles.admin_dashboard__button_citing}
            onClick={() => navigate("/AddSighting")}
          >
            <span className={Styles.icon}>
              <FontAwesomeIcon icon={faMapMarkerAlt} />
            </span>
            Add Sighting
            <div className={Styles.description}>
              Create new sighting entries and location data
            </div>
          </button>
        </div>
        
        <div className={Styles.admin_dashboard__button}>
          <button
            className={Styles.admin_dashboard__button_referrals}
            onClick={() => navigate("/analytics/referrals")}
          >
            <span className={Styles.icon}>
              <FontAwesomeIcon icon={faLink} />
            </span>
            Referrals
            <div className={Styles.description}>
              Track user referrals and top referrers
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Admin;
